import { render, staticRenderFns } from "./UnloadNew.vue?vue&type=template&id=d87a1b8e&scoped=true"
import script from "./UnloadNew.vue?vue&type=script&lang=js"
export * from "./UnloadNew.vue?vue&type=script&lang=js"
import style0 from "./UnloadNew.vue?vue&type=style&index=0&id=d87a1b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87a1b8e",
  null
  
)

export default component.exports